import { businessData as businessDataAtom } from 'atoms';
import InnerPageLayout from 'pages/Business/Partials/InnerPageLayout';
import ServiceTable from 'pages/Business/Service/ServiceTable';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';

import { useAuth } from 'context/AuthContext';

import React, { useEffect, useState } from 'react';

import EmptyService from './EmptyService';
import ServicePopup from './ServicePopup';
import Loader from 'common/Loaders/Loader';

const DataContainer = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flexgrow: 1;
`;

const ServiceHome = () => {
    const { token } = useAuth();
    const [business, setBusiness] = useRecoilState(businessDataAtom);
    const [serviceList, setServiceList] = useState([]);
    const [rows, setRows] = useState([]);
    const [openPopup, setOpenPopup] = useState(false);
    const [loading, setLoading] = useState(false)

    const getServiceList = async () => {
        setLoading(true)
        try {
            // Validate business_id
            if (!business?.id) {
                console.error('Business ID is required');
                setLoading(false);
                return;
            }

            // Validate access token
            if (!token) {
                console.error('No authentication token found');
                setLoading(false);
                return;
            }

            // Make API call to backend
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/api/providers/services`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ business_id: business.id })
                }
            );

            const result = await response.json();

            if (!response.ok || result.error) {
                const errorMessage = result.error || 'Failed to fetch services';
                console.error('Error fetching services:', errorMessage);
                setServiceList([]);
                setRows([]);
                setLoading(false);
                return;
            }

            // Backend returns { success: true, data: [] }
            if (result.success && result.data) {
                // Preserve object structure - do not convert to array
                const data = result.data;
                const serviceData = Array.isArray(data) ? data : (data ? [data] : []);
                setServiceList(serviceData);
                
                if (serviceData?.length > 0) {
                    setRows(serviceData);
                } else {
                    setRows([]);
                }
            } else {
                // Fallback if response format is unexpected
                console.warn('Unexpected response format from services API');
                setServiceList([]);
                setRows([]);
            }
        } catch (err) {
            console.error("Unexpected error:", err);
            setServiceList([]);
            setRows([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (business?.id) {
            getServiceList();
        }
    }, [business?.id]);

    const togglePopup = () => {
        setOpenPopup(!openPopup);
    };

    return (
        <div className='h-full bg-[#F5F1ED]' style={{ display: 'flex', flexDirection: 'column', flex: 1, height: '100%' }}>
            {loading ? <Loader /> : (
                <>
                    {serviceList?.length === 0 && !loading && <EmptyService togglePopup={togglePopup}></EmptyService>}

                    {serviceList?.length > 0 && (
                        <DataContainer>
                        <InnerPageLayout heading="Services" btnText="Add a Service" togglePopup={togglePopup} buttonType="secondary">
                            <ServiceTable rows={rows} getServiceList={getServiceList}></ServiceTable>
                        </InnerPageLayout>
                        </DataContainer>
                    )}

                    <ServicePopup
                        open={openPopup}
                        onClose={togglePopup}
                        getServiceList={getServiceList}
                        businessId={business?.id}
                    ></ServicePopup></>
            )}
        </div>
    );
};

export default ServiceHome;
